/**
 * @fileOverview shape entry file
 * @author huangtonger@aliyun.com
 */


const Shape = require('./shape');
require('./node');
require('./edge');
require('./nodes');
require('./edges');
module.exports = Shape;
